import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialog } from '../../models/dialog.model';

@Component({
    standalone: false,
    selector: 'octo-confirmation-dialog-changed-message',
    templateUrl: './confirmation-dialog-changed-message.component.html',
    styleUrls: ['./confirmation-dialog-changed-message.component.scss'],
})
export class ConfirmationDialogChangedMessageComponent implements OnInit {
    remainingTime = 10;
    primaryMessage = true;

    /**
     * Constructor method.
     *
     * @param {MatDialogRef<ConfirmationDialogComponent>} modalRef - Dialog reference.
     * @param {ConfirmationDialog} data - Dialog data.
     * @param {ChangeDetectorRef} cd - Change detector reference.
     */
    constructor(
        private modalRef: MatDialogRef<ConfirmationDialogChangedMessageComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialog,
        private cd: ChangeDetectorRef
    ) {}

    /**
     * Initialize the component.
     */
    ngOnInit(): void {
        this.cd.detectChanges();
    }

    showNewMessage() {
        this.primaryMessage = false;
        const interval = setInterval(() => {
            this.remainingTime--;
            if (this.remainingTime === 0) {
                clearInterval(interval);
                this.modalRef.close(true);
            }
        }, 1000);
    }

    /**
     * Close the dialog.
     */
    closeDialog() {
        this.modalRef.close(true);
    }

    isPrimaryMessage() {
        return this.primaryMessage;
    }
}
